
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#020202","d":"M14.435 6.063c-.189-.249-.517-.379-.897-.389h-.914V4.278c0-.886-.806-1.235-1.359-1.254 0 0-3.203-.028-4.203-.028h-.004c-.569-.009-.76-.15-.761-.15L5.273 1.771c-.395-.411-.965-.401-1.006-.396H1.518c-.457 0-.728.185-.874.339-.297.315-.29.706-.287.752v9.515c0 .45.085.799.241 1.059.02.046.035.094.063.136.26.392.742.439.92.434 0 0 8.021.016 9.526.016h.188c.902 0 1.359-.658 1.486-1.044l1.779-5.31c.142-.507.099-.913-.125-1.209zM1.518 2.375h2.765c.071 0 .202.02.269.089l.995 1.042c.09.11.464.473 1.503.49.994 0 4.154.028 4.188.028.064.003.386.032.386.254v1.396H3.919a1.56 1.56 0 00-1.49 1.042L1.36 9.891l.011-7.489c.006-.006.047-.027.147-.027zm12.088 4.604l-1.771 5.279a.56.56 0 01-.541.367h-.188c-1.504.001-9.524-.017-9.601.026 0-.001-.015-.083.09-.333l1.78-5.284a.571.571 0 01.542-.361l9.715-.013c.002.002.037.09-.026.319z"}})])
          )
        }
      }
    